import {call, put, select} from "redux-saga/effects";
import * as api from "services/api";
import {invoiceDataSelector} from "store/reducer/payments/invoice/selectors";
import {getErrorFromMessage} from "services/utils/utils";
import {saveInvoiceDataFailure, saveInvoiceDataSuccess} from "store/reducer/payments/invoice/reducer";

export function* saveInvoiceDataSaga() {
    const invoice = yield select(invoiceDataSelector);
    try {
        yield call([api, api.saveInvoicingData], invoice);
        yield put(saveInvoiceDataSuccess());
    } catch (e) {
        yield put(saveInvoiceDataFailure(getErrorFromMessage(e)));
    }
}